/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ProcessingReconcileParams } from './processingReconcileParams';

/**
 * Request model for PROCESSING submission reconciliation job
 */
export interface RunProcessingReconcileJobRequest {
  type: 'submissions_processing_reconcile';
  params: ProcessingReconcileParams;
  allowOverlappingJobs?: boolean;
}
